import NProgress from 'nprogress'; // progress bar
import '../styles/nprogress.css';
import type { PluginOptions } from './type';

const options: PluginOptions = {
  onInit: async () => {
    const node = document.createElement('div');
    node.id = 'n-progress-container';
    node.style.position = 'fixed';
    node.style.width = '100%';
    node.style.height = '10px';
    node.style.top = '0';
    document.body.appendChild(node);
    let pending = false;

    // 1. 重写对应方法，避免强制回流
    // 2. 在路由切换时，康师傅的 SF-vine 会导致 push 和 replace 这么两次路由变更，导致 NProgress.start 及 NProgress.done 会被触发多次，这里拦截下
    const { start } = NProgress;
    NProgress.start = () => {
      if (pending) {
        return NProgress;
      }
      pending = true;

      const barContainer = node.firstElementChild as HTMLElement | null;
      if (barContainer) {
        barContainer.style.opacity = '1';
        NProgress.trickle();
      }

      node.style.display = 'block';
      return start();
    };
    NProgress.remove = () => {
      node.style.display = 'none';

      const bar = node.querySelector('.bar') as HTMLElement | null;
      if (bar) {
        bar.style.transform = 'translate3d(-100%, 0, 0)';
      }

      pending = false;
    };

    NProgress.configure({ parent: '#n-progress-container', showSpinner: false }); // NProgress Configuration
  },
};

export default options;
